<div class="page">
    <div class="submission-success-container">
        <div class="success-header">
            <div class="success-icon" [ngClass]="{'submitted-success': submitted}">
                <div class="checkmark-circle">
                    <svg class="checkmark" viewBox="0 0 52 52">
                        <circle class="checkmark-circle" cx="26" cy="26" r="23" />
                        <path class="checkmark-check" d="M14 27l7 7 16-16" />
                    </svg>
                </div>
            </div>
            <h1 class="success-title" [ngClass]="{'submitted-success': submitted}">
                Submission Complete : {{currentYear}}
            </h1>
            <span class="prfinfo">{{prfNumber}}: {{prfName}}</span>
            <p class="success-description" *ngIf="submitted">
                Your {{ 'app.name' | label }} has been successfully submitted.
            </p>
            <div class="heading-row-line"> <a (click)="navigateToSubmissionSummary()" class="view-more-link">
            Click Here
        </a> to view Submission Summary</div>
            <p class="success-description" *ngIf="!submitted">
                Thank you for your submission.Your {{ 'app.name' | label }} has been successfully
                submitted and is now under review.
            </p>
        </div>
        <div class="important-notice" *ngIf="!submitted">
            <div class="notice-content">
                <svg class="warning-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 
          3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="notice-text">
                    <strong>The premium report form is in Validation Stage.</strong><br>
                    Your premium report is under review and a representative will be in

                    contact if any issues are detected and need to be addressed.
                </div>
            </div>
        </div>
        <div class="navigation-boxes" *ngIf="!submitted">
            <div class="nav-box">
                <p>Click here to return to the <a [routerLink]="['/dboard']" class="nav-link">PRF List page</a>.</p>
            </div>
            <div class="nav-box">
                <p>Click here to go to the <a
                        [routerLink]="['/' + currentYear + '/' + prfNumber + '/validationsummary']"
                        class="nav-link">Validation Summary page</a>.</p>
            </div>
        </div>

        <div class="help-section">
            <h3>Need Help or Have Questions?</h3>
            <p class="help-description">
                Contact our support team at <a>PremiumReportForm&commat;iso.com</a> or call
                <a>(201) 469-3045</a>
            </p>
            <p class="reference-id">
                <ng-container *ngIf="validationJobId">
                    Reference your Submission ID: <strong>PRF-{{validationJobId | uppercase}}</strong>
                </ng-container>
            </p>
        </div>
    </div>
</div>